import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export const FloatingNotification = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [notificationData, setNotificationData] = useState({
    name: 'Florencia B.',
    location: 'La Plata',
    product: 'Kit REFLEXO-PRO Completo 🦶',
    time: 'hace 9 minutos'
  });
  const buyers = [{
    name: 'Florencia B.',
    location: 'La Plata',
    product: 'Kit REFLEXO-PRO Completo 🦶',
    time: 'hace 9 minutos'
  }, {
    name: 'Valentina G.',
    location: 'Buenos Aires',
    product: 'Kit REFLEXO-PRO Completo 🦶',
    time: 'hace 14 minutos'
  }, {
    name: 'Carolina R.',
    location: 'Córdoba',
    product: 'Kit REFLEXO-PRO Completo 🦶',
    time: 'hace 22 minutos'
  }, {
    name: 'Marcela F.',
    location: 'Rosario',
    product: 'Kit REFLEXO-PRO Completo 🦶',
    time: 'hace 35 minutos'
  }, {
    name: 'Luciana M.',
    location: 'CABA',
    product: 'Kit REFLEXO-PRO Completo 🦶',
    time: 'hace 41 minutos'
  }];
  useEffect(() => {
    // Initial delay before showing the first notification
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    // Cycle notifications
    const cycleTimer = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
        // Randomize time slightly for realism
        const randomTime = `hace ${Math.floor(Math.random() * 59) + 1} minutos`;
        setNotificationData({
          ...randomBuyer,
          time: randomTime
        });
        setIsVisible(true);
      }, 1000); // Wait 1s before showing the next one
    }, 30000); // Show a new notification every 30 seconds
    return () => {
      clearTimeout(initialTimer);
      clearInterval(cycleTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-88">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 25
    }} className="fixed bottom-4 left-4 md:bottom-8 md:left-8 z-50 max-w-sm" data-id="element-89">
          <div className="glass-panel bg-white/95 p-4 rounded-2xl shadow-xl border-brand-pink/30 flex items-start space-x-4 backdrop-blur-md" data-id="element-90">
            <div className="bg-brand-green/10 p-2 rounded-full shrink-0 mt-1" data-id="element-91">
              <CheckCircle2 className="w-5 h-5 text-brand-green" data-id="element-92" />
            </div>
            <div data-id="element-93">
              <div className="text-xs text-brand-text/60 mb-1 flex items-center" data-id="element-94">
                🔔 Compra verificada • {notificationData.time}
              </div>
              <div className="text-sm font-medium text-brand-text mb-1" data-id="element-95">
                <span className="font-bold" data-id="element-96">{notificationData.name}</span> de{' '}
                {notificationData.location} compró
              </div>
              <div className="text-sm text-brand-rose font-medium" data-id="element-97">
                {notificationData.product}
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
};